import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Stream from './views/Stream.vue';
import LoginPage from './views/LoginPage.vue';
import store from '@/store';

Vue.use(Router);

export default new Router({
	//mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/stream',
			name: 'stream',
			component: Stream,

		},
		{
			path: '/stream/:stream_id(\\w+)',
			name: 'stream_with_id',
			component: Stream,

		},
		{
			path: '/login',
			name: 'login',
			component: LoginPage,
			beforeEnter(to, from, next) {
				if (store.getters.user) {
					next({name: 'home'});
				} else {
					next();
				}
			}
		},
		{
			path: '/logout',
			name: 'Logout',
			beforeEnter(to, from, next) {
				if (store.getters.user) {
					store.dispatch('postLogout');
					next(from.path);
				} else {
					next('/');
				}
			}
		},
		{
			path: '/about',
			name: 'about',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
		},
		{
			path: '/flash',
			name: 'flash',
			// route level code-splitting
			// this generates a separate chunk (about.[hash].js) for this route
			// which is lazy-loaded when the route is visited.
			component: () => import(/* webpackChunkName: "about" */ './views/Flash.vue')
		},
		{
			path: '/impressum',
			name: 'Impressum',
			component: () => import(/* webpackChunkName: "impressum" */ './views/Impressum.vue')
		}
	]
});
